var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2ED6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3565 9.91125H10.8427C11.0634 9.91059 11.2817 9.86647 11.4853 9.78142C11.6889 9.69637 11.8738 9.57205 12.0293 9.41556C12.1849 9.25907 12.3081 9.07347 12.3919 8.86937C12.4757 8.66526 12.5185 8.44665 12.5179 8.226C12.5191 7.78048 12.3433 7.35273 12.0291 7.03681C11.715 6.72088 11.2883 6.54265 10.8427 6.54131H10.0519L8.3565 5.0625H10.8427C11.574 5.06425 12.2819 5.32027 12.8451 5.7867C13.4083 6.25313 13.7918 6.90093 13.9297 7.61906C14.0706 8.33761 13.9583 9.08277 13.6117 9.72782C13.2652 10.3729 12.706 10.878 12.0291 11.1572L13.9894 12.8683H11.7444L8.3565 9.91069V9.91125ZM9.56981 8.02125H7.08356C6.63814 8.02259 6.21148 8.20074 5.89737 8.51655C5.58325 8.83235 5.40739 9.25996 5.40843 9.70537C5.40724 10.1509 5.58303 10.5786 5.89717 10.8946C6.2113 11.2105 6.63804 11.3887 7.08356 11.3901H7.875L9.56925 12.8694H7.08356C6.35229 12.8677 5.64439 12.6117 5.08119 12.1452C4.51798 11.6788 4.13453 11.031 3.99656 10.3129C3.85568 9.59433 3.96805 8.84917 4.31457 8.20412C4.66109 7.55908 5.22035 7.05399 5.89725 6.77475L3.93862 5.0625H6.18356L9.56981 8.02125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcr);
export default __webpack_public_path__ + "static/media/dcr.efb8644a23113592a4a28a5e76916cd3.svg";
export { ForwardRef as ReactComponent };